import request from '../utils/request';

export const PayAPI = {

    /**
     * 获取支付
     */
    generalPay(orderNo) {
        return request({
            url: "/api/pay/test/general",
            method: "get",
            params: { "tradeNo": orderNo }
        })
    },

    /**
     * 获取支付
     */
    queryPay(orderNo) {
        return request({
            url: "/api/pay/test/query",
            method: "get",
            params: { "tradeNo": orderNo }
        })
    },


}


// WEBPACK FOOTER //
// ./src/api/pay.js